import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { makeT } from '../../../../group_leader/helpers/i18n'

// The starting hole, typed; the letter ("10A") is server-derived and sent only when typed.

const t = makeT('group_leader.event_setup.pairings')

const FIRST_HOLE = 1
const HOLE_PATTERN = /^(\d{1,2})\s*([A-Za-z])?$/

const HoleCell = ({ hole, holeLetter, foursomeId, onSave, holeCount }) => {
  const serverValue = `${hole}${holeLetter || ''}`
  const [ draft, setDraft ] = useState(serverValue)

  // Follows the server: a shotgun reassigns every group's hole, and letters shift as groups move.
  useEffect(() => { setDraft(serverValue) }, [ serverValue ])

  const commit = () => {
    const match = draft.trim().match(HOLE_PATTERN)
    const number = match ? parseInt(match[1], 10) : NaN
    const valid = match && number >= FIRST_HOLE && number <= holeCount
    if (!valid) {
      setDraft(serverValue)
      return
    }
    const letter = match[2] ? match[2].toUpperCase() : null
    if (number !== Number(hole) || letter !== (holeLetter || null)) {
      onSave(foursomeId, number, letter)
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.currentTarget.blur()
    }
    if (event.key === 'Escape') {
      setDraft(serverValue)
      event.currentTarget.blur()
    }
  }

  return (
    <input
      className="gl-event-setup-sh-hole"
      type="text"
      maxLength={3}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={handleKeyDown}
      aria-label={t('sheet.hole_aria', { n: serverValue })}
    />
  )
}

HoleCell.propTypes = {
  hole: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
  // Assigned by the server when groups share a hole; absent for most foursomes
  holeLetter: PropTypes.string,
  foursomeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
  onSave: PropTypes.func.isRequired,
  // The course's hole count, so a nine-hole round refuses hole 14 here as the panel does.
  holeCount: PropTypes.number.isRequired,
}

export default HoleCell
